import { render } from "./ManagerCompanyInfoSection.vue?vue&type=template&id=527c1da1"
import script from "./ManagerCompanyInfoSection.vue?vue&type=script&lang=js"
export * from "./ManagerCompanyInfoSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__